/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw } from 'lucide-react'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Modal,
  Row,
  Table,
  Card,
  InputGroup,
  Badge
} from 'react-bootstrap'
import Loader from '../../components/atoms/Loader'
import RowEmpty from '../../components/atoms/RowEmpty'
import TablePagination from '../../components/atoms/Table/TablePagination'
import api from '../../config/AxiosInstance'
import '../../styles/style.css'
import { useLocation, useNavigate } from 'react-router-dom'
import InputDatePicker from '../../components/Input/DatePicker/InputDatePicker'
import { convertDateWithTime } from '../../helpers/constants'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import Select from 'react-select'
import toast, { Toaster } from 'react-hot-toast'

const TYPE_OPTIONS = [
  { value: '', label: 'All Types' },
  { value: 'item', label: 'Item' },
  { value: 'vas', label: 'VAS' },
  { value: 'packing', label: 'Packing' }
]

const cardFilterStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  padding: '1.5rem',
  marginBottom: '1.5rem'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const customStyles = {
  control: (base, state) => ({
    ...base,
    background: '#fff',
    borderColor: state.isFocused ? '#f89d1d' : '#e9ecef',
    borderRadius: '8px',
    boxShadow: state.isFocused
      ? '0 0 0 0.2rem rgba(248, 157, 29, 0.25)'
      : 'none',
    fontSize: '0.9rem',
    padding: '2px',
    '&:hover': {
      borderColor: '#f89d1d'
    }
  }),
  placeholder: (base) => ({
    ...base,
    color: '#adb5bd'
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#f89d1d'
      : state.isFocused
        ? '#fff3cd'
        : null,
    color: state.isSelected ? 'white' : '#333',
    fontSize: '0.9rem',
    cursor: 'pointer',
    ':active': {
      ...base[':active'],
      backgroundColor: '#f89d1d'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px'
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px'
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999
  })
}

const StockAdjustment = () => {
  const headerTitleStyle = {
    color: '#343a40',
    fontSize: '1.5rem',
    fontWeight: '700',
    letterSpacing: '-0.5px'
  }

  const { state } = useLocation()
  const refWarehouses = useRef()
  const [isLoading, setIsLoading] = useState(false)
  const [warehouses, setWarehouses] = useState([])
  const [visible, setVisible] = useState({
    import: false,
    fromBa: false,
    confirmFromBa: false
  })
  const navigate = useNavigate()
  const [filter, setFilter] = useState({
    warehouse_id: state?.warehouse_id || '',
    type: state?.type || '',
    start_date: state?.start_date || '',
    end_date: state?.end_date || ''
  })
  const [selectedWarehouse, setSelectedWarehouse] = useState(null)
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const [form, setForm] = useState({
    warehouseSelected: '',
    type: null
  })
  const [data, setData] = useState([])
  const [beritaAcaraDatas, setBeritaAcaraDatas] = useState([])
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [selectBA, setSelectBA] = useState(null)
  const { per_page, current_page } = meta

  const fetchWarehouse = async () => {
    try {
      const params = {
        type: 'internal',
        forUser: true,
        child: true
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      const options = data.map((w) => ({
        value: w.id,
        label: w.warehouse_name
      }))
      setWarehouses(options)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const handleFilterChange = (name, value) => {
    setFilter((prev) => {
      const newFilter = { ...prev, [name]: value }
      if (name === 'start_date' && value && prev.end_date) {
        if (new Date(value) > new Date(prev.end_date)) {
          newFilter.end_date = value
        }
      } else if (name === 'end_date' && value && prev.start_date) {
        if (new Date(value) < new Date(prev.start_date)) {
          newFilter.start_date = value
        }
      }
      return newFilter
    })
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const fetchStockAdjustment = async () => {
    try {
      setIsLoading(true)
      const params = {
        per_page,
        page: current_page,
        warehouse_id: filter.warehouse_id
      }
      if (debouncedSearch) params.q = debouncedSearch
      if (filter.type) params.type = filter.type
      if (filter.start_date && filter.end_date) {
        params.start_date = convertDateWithTime(filter.start_date, 'YYYY-MM-DD')
        params.end_date = convertDateWithTime(filter.end_date, 'YYYY-MM-DD')
      }

      const res = await api.get('stock-adjustment', { params })
      const { metadata, data } = res.data
      setData(data)
      setMeta(metadata)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (warehouses.length > 0 && filter.warehouse_id) {
      const found = warehouses.find((w) => w.value === filter.warehouse_id)
      if (found) setSelectedWarehouse(found)
    }
  }, [warehouses])

  const renderAction = (data) => (
    <div key={data.id}>
      <button
        className="btn btn-light text-secondary border rounded"
        style={{
          width: '32px',
          height: '32px',
          padding: 0,
          marginRight: '8px'
        }}
        onClick={() =>
          navigate(`/stock-adjustment/detail/${data.id}`, {
            state: {
              code: data.code,
              warehouse_id: filter.warehouse_id
            }
          })
        }
        title="View Detail"
      >
        <Search size={16} />
      </button>
    </div>
  )
  const handleCloseModal = (key, confirm = false) => {
    if (key === 'import') {
      setForm({
        warehouseSelected: '',
        type: null
      })
    }
    const isVisibleValue = !visible[key]
    if (key === 'fromBa' && !isVisibleValue && confirm) {
      setVisible((prevVisible) => ({
        ...prevVisible,
        fromBa: false
      }))
      setTimeout(() => {
        setVisible((prevVisible) => ({
          ...prevVisible,
          confirmFromBa: true
        }))
      }, 1000)
      return
    }
    if (key === 'confirmFromBa' && !isVisibleValue) {
      setBeritaAcaraDatas([])
      setSelectBA(null)
    }
    setVisible((prevVisible) => ({
      ...prevVisible,
      [key]: isVisibleValue
    }))
  }
  const renderType = (type) => {
    if (type === 'vas') {
      return (
        <Badge bg="warning" text="dark" className="px-2 py-1 text-uppercase">
          VAS
        </Badge>
      )
    }
    if (type === 'packing') {
      return (
        <Badge bg="info" className="px-2 py-1 text-uppercase">
          Packing
        </Badge>
      )
    }
    return (
      <Badge bg="secondary" className="px-2 py-1 text-uppercase">
        Item
      </Badge>
    )
  }

  const columns = [
    { key: 'code', label: 'Ticket' },
    { key: 'erp_code', label: 'ERP Code' },
    { key: 'warehouse_id', label: 'Warehouse' },
    {
      key: 'type',
      label: 'Type',
      component: (data) => renderType(data.type)
    },
    {
      key: 'related_ticket',
      label: 'Related Ticket',
      component: (data) => (
        <span
          style={{
            color: `${
              data.related_ticket !== 'No Relation' ? '#2F80ED' : 'black'
            }`
          }}
        >
          {data.related_ticket}
        </span>
      )
    },
    { key: 'created_at', label: 'Created Date' },
    { key: 'action', label: 'Action', component: (data) => renderAction(data) }
  ]
  const columnItemBAs = [
    { key: 'code', label: '#BA' },
    { key: 'warehouse', label: 'Source Warehouse' },
    {
      key: 'action',
      label: 'Action',
      component: (data) => (
        <div key={data.id}>
          <Button
            variant="transparent"
            className="btn btn-primary-blue text-light text-uppercase rounded px-3"
            onClick={() => {
              setSelectBA(data)
              handleCloseModal('fromBa', true)
            }}
          >
            Select
          </Button>
        </div>
      )
    }
  ]
  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    const selectedPage = data.selected + 1
    setMeta((prevMeta) => ({ ...prevMeta, current_page: selectedPage }))
    window.scrollTo(0, 0)
  }

  const handleForm = (e) => {
    const { value, name } = e
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value
    }))
  }

  const ModalProps = useMemo(() => {
    if (visible.import) {
      return {
        key: 'import',
        title: 'Create Stock Adjustment',
        style: { maxHeight: 'calc(100vh - 200px)' }
      }
    }
    if (visible.fromBa) {
      return {
        key: 'fromBa',
        title: 'Select BA',
        style: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }
      }
    }
    if (visible.confirmFromBa) {
      return {
        key: 'confirmFromBa',
        title: '',
        style: { maxHeight: '320px', overflowY: 'auto' }
      }
    }
    return {
      key: '',
      title: ''
    }
  }, [visible])

  const fetchBA = async () => {
    try {
      const response = await api.get('/stock-adjustment/all-event-report')
      const { data } = response.data
      setBeritaAcaraDatas(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  useEffect(() => {
    fetchWarehouse()
  }, [])

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [search])

  useEffect(() => {
    if (
      (filter.warehouse_id && filter.warehouse_id !== '') ||
      debouncedSearch
    ) {
      if (
        (filter.start_date && !filter.end_date) ||
        (!filter.start_date && filter.end_date)
      ) {
        return
      }
      fetchStockAdjustment()
    }
  }, [
    meta.current_page,
    meta.per_page,
    filter.warehouse_id,
    filter.type,
    filter.start_date,
    filter.end_date,
    debouncedSearch
  ])

  useEffect(() => {
    if (visible?.fromBa) {
      fetchBA()
    }
  }, [visible?.fromBa])

  const resetFilter = () => {
    setFilter({
      warehouse_id: '',
      type: '',
      start_date: '',
      end_date: ''
    })
    setSelectedWarehouse(null)
    setSearch('')
    setDebouncedSearch('')
    setMeta((prev) => ({ ...prev, current_page: 1 }))
    setData([])
  }

  return (
    <div className="container-fluid px-4 mb-5">
      <Row className="mb-4 align-items-center">
        <Col>
          <h3 style={headerTitleStyle}>Stock Adjustment</h3>
        </Col>
        <Col className="text-end">
          <div className="d-flex justify-content-end gap-2">
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={resetFilter}
              style={{ fontSize: '0.85rem' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>

            <Dropdown className="create-stock-adjustment">
              <Dropdown.Toggle
                variant="transparent"
                id="dropdown-basic"
                className="p-0 border-0"
              >
                <button
                  type="button"
                  className="btn btn-primary-blue rounded px-3"
                >
                  <small className="fw-bold">+ Create</small>
                </button>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    setVisible((prevVisible) => ({
                      ...prevVisible,
                      import: true
                    }))
                  }}
                >
                  Import Initial Data
                </Dropdown.Item>
                <Dropdown.Item
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    setVisible((prevVisible) => ({
                      ...prevVisible,
                      fromBa: true
                    }))
                  }}
                >
                  Create From BA
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row className="g-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label style={labelStyle}>Search</Form.Label>
              <InputGroup>
                <InputGroup.Text
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRight: 'none',
                    borderTopLeftRadius: '10px',
                    borderBottomLeftRadius: '10px'
                  }}
                >
                  <Search size={18} className="text-muted" />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search Ticket..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                  }}
                  style={{
                    ...FormControlStyle,
                    borderLeft: 'none',
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0
                  }}
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse Name</Form.Label>
              <Select
                options={warehouses}
                value={selectedWarehouse}
                onChange={(opt) => {
                  setSelectedWarehouse(opt)
                  handleFilterChange('warehouse_id', opt ? opt.value : '')
                }}
                placeholder="Select Warehouse"
                styles={customStyles}
                isClearable
                menuPortalTarget={document.body}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>Type</Form.Label>
              <Select
                options={TYPE_OPTIONS}
                value={TYPE_OPTIONS.find((o) => o.value === filter.type)}
                onChange={(opt) => handleFilterChange('type', opt?.value || '')}
                placeholder="All Types"
                styles={customStyles}
                menuPortalTarget={document.body}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>Start Date</Form.Label>
              <div
                style={FormControlStyle}
                className="d-flex align-items-center px-2"
              >
                <InputDatePicker
                  value={filter?.start_date}
                  onChange={(date) => handleFilterChange('start_date', date)}
                  maxDate={filter.end_date ? new Date(filter.end_date) : null}
                  clearIcon
                />
              </div>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label style={labelStyle}>End Date</Form.Label>
              <div
                style={FormControlStyle}
                className="d-flex align-items-center px-2"
              >
                <InputDatePicker
                  value={filter?.end_date}
                  onChange={(date) => handleFilterChange('end_date', date)}
                  minDate={
                    filter.start_date ? new Date(filter.start_date) : null
                  }
                  clearIcon
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col md={12}>
          <Table
            hover
            responsive
            className="shadow-sm mb-5 bg-white"
            style={{
              fontSize: '0.9rem',
              borderRadius: '12px',
              overflow: 'hidden'
            }}
          >
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columns.map((column) => (
                  <th
                    className="p-2 align-middle"
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    {column.key !== 'checkbox' && <span>{column.label}</span>}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoading && (
                <tr>
                  <td colSpan={columns.length} className="text-center p-5">
                    <Loader />
                  </td>
                </tr>
              )}
              {!isLoading && !data.length && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="text-center p-5 text-muted fw-bold"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
              {!isLoading &&
                data.length > 0 &&
                data.map((item, index) => (
                  <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    {columns.map((column) => (
                      <td key={column.key} className="p-2 align-middle">
                        {column.component && column.component(item)}
                        {column.key !== 'action' &&
                          !column.component &&
                          (item[column.key] ?? '-')}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="p-3 border-top-0" colSpan={columns.length}>
                  <TablePagination
                    meta={meta}
                    handlePageChange={handlePageChange}
                    handleOnChangeMeta={handleOnChangeMeta}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Col>
      </Row>
      <ModalStockAdjustment
        show={Object.values(visible).some((v) => v)}
        title={ModalProps.title}
        onHide={() => {
          handleCloseModal(ModalProps.key)
        }}
        size="md"
        backdrop="static"
      >
        <Modal.Body style={ModalProps.style}>
          {ModalProps.key === 'import' && (
            <>
              <Row className="mt-2 p-2">
                <h6
                  className="text-muted text-uppercase fw-bold"
                  style={{ fontSize: '13px' }}
                >
                  Select Warehouse and Type
                </h6>
                <Col md={12} className="my-2">
                  <Form.Group>
                    <Form.Label htmlFor="warehouseSelected">
                      <small
                        className="text-secondary fw-bold text-uppercase"
                        style={{ fontSize: '11px' }}
                      >
                        warehouse name
                      </small>
                    </Form.Label>
                    <Select
                      isClearable
                      defaultValue={form.warehouseSelected || ''}
                      styles={customStyles}
                      onChange={(e) => {
                        if (!e) {
                          e = {
                            target: refWarehouses,
                            value: ''
                          }
                        }
                        handleForm({
                          name: 'warehouseSelected',
                          value: e?.value
                        })
                      }}
                      options={warehouses?.map((warehouse) => {
                        return {
                          value: warehouse.value,
                          label: warehouse.label
                        }
                      })}
                      isSearchable
                      ref={refWarehouses}
                      menuPortalTarget={document.body}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>
                      <small
                        className="text-secondary fw-bold text-uppercase"
                        style={{ fontSize: '11px' }}
                      >
                        Type
                      </small>
                    </Form.Label>
                    <div className="d-flex gap-3">
                      <Form.Check
                        inline
                        type="radio"
                        name="type"
                        label="Item"
                        id="type-item"
                        style={{ transform: 'scale(1.1)' }}
                        checked={form.type === 'item'}
                        onChange={(e) =>
                          handleForm({
                            name: 'type',
                            value: 'item'
                          })
                        }
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="type-packing"
                        name="type"
                        label="Packing"
                        style={{ transform: 'scale(1.1)' }}
                        checked={form.type === 'packing'}
                        onChange={(e) =>
                          handleForm({
                            name: 'type',
                            value: 'packing'
                          })
                        }
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="type-vas"
                        name="type"
                        label="VAS"
                        style={{ transform: 'scale(1.1)' }}
                        checked={form.type === 'vas'}
                        onChange={(e) =>
                          handleForm({
                            name: 'type',
                            value: 'vas'
                          })
                        }
                      />
                    </div>
                  </Form.Group>
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className={`btn ${
                    !form.warehouseSelected || !form.type
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange text-white'
                  } `}
                  disabled={!form.warehouseSelected || !form.type}
                  onClick={(e) => {
                    e.preventDefault()
                    navigate('/stock-adjustment/create', {
                      state: {
                        warehouse_id: form.warehouseSelected,
                        warehouse_name: warehouses.find(
                          (warehouse) =>
                            warehouse.value === form.warehouseSelected
                        )?.label,
                        type: form.type,
                        is_packing: form.type === 'packing',
                        is_vas: form.type === 'vas'
                      }
                    })
                  }}
                >
                  Next
                </button>
              </div>
            </>
          )}
          {ModalProps.key === 'fromBa' && (
            <Table
              responsive
              hover
              className="shadow-sm mb-5 bg-white rounded"
              size="sm"
              style={{ fontSize: '14px' }}
            >
              <thead className="table-secondary">
                <tr>
                  {columnItemBAs.map((column) => (
                    <th className="align-middle p-2" key={column.key}>
                      {column.key !== 'checkbox' && <span>{column.label}</span>}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan={columnItemBAs.length}>
                      <Loader />
                    </td>
                  </tr>
                )}
                {!isLoading && !beritaAcaraDatas.length && (
                  <RowEmpty colSpan={columnItemBAs.length} />
                )}
                {!isLoading &&
                  beritaAcaraDatas.length > 0 &&
                  beritaAcaraDatas.map((item, index) => (
                    <tr key={index}>
                      {columnItemBAs.map((column) => (
                        <td key={column.key} className="p-2 align-middle">
                          {column.component && column.component(item)}
                          {column.key !== 'action' &&
                            !column.component &&
                            (item[column.key] ?? '-')}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
          {ModalProps.key === 'confirmFromBa' && (
            <>
              <div className="d-flex flex-column gap-2 text-center fs-6 my-2">
                <div className="d-flex justify-content-center my-3">
                  <svg
                    width="181"
                    height="180"
                    viewBox="0 0 181 180"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                      fill="#828282"
                    />
                    <path
                      d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                      fill="#828282"
                    />
                  </svg>
                </div>
                <p>
                  Crate Stock Adjustment from{' '}
                  <span className="fw-bold">{selectBA?.code || ''}</span> ?
                </p>
              </div>
              <Modal.Footer>
                <>
                  <Button
                    variant="transparent"
                    onClick={() => handleCloseModal('confirmFromBa')}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="transparent"
                    className="btn-primary-orange"
                    onClick={(e) => {
                      e.preventDefault()
                      navigate('/stock-adjustment/create', {
                        state: {
                          ...selectBA
                        }
                      })
                    }}
                  >
                    Creating Ticket
                  </Button>
                </>
              </Modal.Footer>
            </>
          )}
        </Modal.Body>
      </ModalStockAdjustment>
      <Toaster />
    </div>
  )
}

export default StockAdjustment
